import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

const SelectSpecialtyType = ({ onSelect }) => (
	<Box>
		<Typography variant='h5' component='h1' color='primary' sx={{ mb: 2 }}>
			Specialty
		</Typography>
		<Typography fontWeight='bold'>Rehabilitation Services:</Typography>
		<RadioGroup
			data-testid='select-specialty-type'
			onChange={(e, v) => {
				onSelect(v);
			}}
		>
			<FormControlLabel
				value='PT'
				control={<Radio />}
				label='Physical Therapy (PT)'
			/>
			<FormControlLabel
				value='OT'
				control={<Radio />}
				label='Occupational Therapy (OT)'
			/>
			{/* ST, AT, and MD are hidden for later use as mentioned on this PBI 709612. Once ready to use, their hardcoded docId values will need to be updated accordingly in SpecialtyTypeHelpers.js */}
			{/* <FormControlLabel
                value='ST'
                control={<Radio />}
                label='Speech Therapy / Speech Language Pathology (ST/SLP)'
            />
            <FormControlLabel
                value='AT'
                control={<Radio />}
                label='Athletic Trainer (AT)'
            />
            <FormControlLabel
                value='MD'
                control={<Radio />}
                label='Medical Doctor (MD)'
            /> */}
		</RadioGroup>
	</Box>
);

SelectSpecialtyType.propTypes = {
	onSelect: PropTypes.func.isRequired,
};

export default SelectSpecialtyType;
